module.exports = "* {\n    font-weight: 700;\n}\n.card {\n    background-color: #183b78;\n    cursor: pointer !important;\n    width: 90%;\n    z-index: 10000 !important;\n}\n.card-body {\n    background-color: #25457e;\n    padding-top: 10px;\n    padding-bottom: 0px;\n}\n.card-body:hover{\n    background-color: #111e3d;\n}\n.card-title {\n    font-size: 14px;\n    font-weight: bold !important;\n}\n.material-icons {\n  font-size: 70px;\n}\n@media (max-width: 768px) {\n    .card {\n        width: 100%;\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/gerenciador/dashboard/inicio/inicio.component.css
// module id = ./src/app/gerenciador/dashboard/inicio/inicio.component.css
// module chunks = main